import { useEffect, useMemo } from 'react';

import { useAppSelector } from 'store/store-hooks';
import { getVideoUrl } from 'components/app/_helpers/_app.helper';
import { Clip } from 'components/app/editor/_mediator/editor.slice';
import styles from './_sb-player.module.scss';

interface Props {
  clipData?: Clip;
  setInitPlayer: React.Dispatch<React.SetStateAction<boolean>>;
  imgRef: React.RefObject<HTMLImageElement>;
}

export const SbPlayerImg = ({ clipData, setInitPlayer, imgRef }: Props) => {
  const files = useAppSelector((state) => state.app__files.files);

  const src = useMemo(() => {
    if (!clipData) return '';
    return getVideoUrl(files[clipData.mediaFileId]);
  }, [clipData?.clipId]);

  useEffect(() => {
    if (clipData) setInitPlayer(false);
  }, [clipData?.clipId]);

  return (
    <div className={styles.player__image}>
      <img src={src} ref={imgRef} onLoad={() => setInitPlayer(true)} crossOrigin="anonymous" />
    </div>
  );
};
